// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__s7O1o","logo":"header_logo__37dZv","small":"header_small__3HW1S","large":"header_large__3Fj5l","heading":"header_heading__oli8J"};